export default {
  successfully_updated: `Congratulation! 
    You have successfully update information.`,
  image_over_5mb: 'File too large. Please select file size less than or equal to 5mb.',
  please_install_testnet: 'Please install testnet.spectre-rpc',
  please_install_spectre: 'Please install spectre-rpc.io',
  please_install_metamask: 'Please install Metamask',
  please_login_metamask: 'Please login to Metamask wallet and grant login permission to meta-horse system',
  please_login_token_pocket: 'Please login to Token Pocket wallet and grant login permission to meta-horse system',
  please_install_token_pocket: 'Please install Token Pocket'
}
